import React from 'react'

const DOPPELGANGER_ID = 'mote-transcript-inline-doppelganger'
const DOPPELGANGER_SELECTOR = `#${DOPPELGANGER_ID}`

export function useTranscriptDoppelganger(element, fontSize, width, height) {
  const doppelganger = React.useRef(null)
  const doppelgangerParent = React.useRef(null)

  React.useEffect(() => {
    if (doppelganger.current || doppelgangerParent.current) return
    if (!width || !fontSize) return

    createDoppelganger()
  }, [width, fontSize, doppelganger.current, doppelgangerParent.current])

  function createDoppelganger() {
    let el = document.querySelector(DOPPELGANGER_SELECTOR)

    if (el) {
      doppelgangerParent.current = el
      doppelganger.current = el.firstElementChild

      Object.assign(el.style, {
        width: `${width}px`,
        fontSize: `${fontSize}px`
      })
      return
    }

    el = document.createElement('div')
    el.setAttribute('id', DOPPELGANGER_ID)
    el.setAttribute('tabindex', -1)
    el.setAttribute('aria-hidden', true)

    Object.assign(el.style, {
      fontStyle: 'normal',
      margin: '0px',
      textAlign: 'center',
      width: `${width}px`,
      fontSize: `${fontSize}px`,
      position: 'absolute',
      left: '-1000px',
      top: '-1000px'
    })

    document.body.appendChild(el)

    const child = document.createElement('div')

    Object.assign(child.style, {
      width: '80%',
      margin: '0 auto',
      lineHeight: '130%',
      fontWeight: 400
    })

    el.appendChild(child)

    doppelgangerParent.current = el
    doppelganger.current = child
  }

  function checkFit(text) {
    if (!doppelganger.current || !doppelgangerParent.current) return false

    doppelgangerParent.current.style.width = `${width}px`
    doppelganger.current.style.fontSize = `${fontSize}px`
    doppelganger.current.textContent = text

    return Math.round(doppelganger.current.clientHeight) <= Math.round(height)
  }

  return { checkFit }
}
